<template>
  <div>
    <div class="launch-content" v-show="isShowList">
      <Ad activeType="materialManage">
        <span slot="materialManage">
          <List @create="handleCreate" @edit="handleEdit" @read="handleRead" ref="list"></List>
        </span>
      </Ad>
    </div>
    <div v-if="!isShowList && mode !=='read'">
       <Add :mode="mode" :id="id" :materiaObj="materiaObj" @go-back="handleGoBack"></Add>
    </div>
  </div>
</template>
<script>
import Ad from '@/components/Ad'
import List from './MaterialManageList'
import Add from './MaterialManageAdd'

export default {
  components: {
    Ad,
    List,
    Add
  },
  data() {
    return {
      isShowList: true,
      id: undefined,
      mode: 'create',
      materiaObj: {}
    }
  },
  methods: {
    // quickSearch() {
    //   this.$refs.list.fetchDataDebounced()
    // },
    handleCreate() {
      this.isShowList = false
      this.mode = 'create'
      this.id = undefined
    },
    handleEdit(item) {
      this.id = item.mediaId
      this.materiaObj = item
      this.mode = 'edit'
      this.isShowList = false
    },
    handleRead(item) {
      this.id = item.mediaId
      this.materiaObj = item
      this.mode = 'read'
      this.isShowList = false
    },
    handleGoBack(item) {
      this.isShowList = true
      this.mode = 'list'
      this.$nextTick(() => {
        this.$refs.list.fetchData()
      })
    }
  },
  created() {
  }
}
</script>
<style lang="stylus" scoped>
</style>
